export function mask(cpf: string) {
  if (!cpf) {
    return '';
  }

  return cpf
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
}

export function unMask(cpf: string) {
  return cpf.replace(/\D/g, '');
}

export default {
  mask,
  unMask
}
